import { useState, useEffect } from 'react';
import { useLanguage } from '../../../contexts/useLanguage';
import aicomicLogo from '../../../assets/readdy/60ff3a18dd5605b1f76c7856e3032bde__dd3962c993.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const content = {
    zh: {
      home: '首页',
      aiComic: 'AI漫画',
      emotionalAi: '情感AI',
      download: '下载'
    },
    en: {
      home: 'Home',
      aiComic: 'AI Comic',
      emotionalAi: 'Emotional AI',
      download: 'Download'
    }
  };

  const t = content[language];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center space-x-3 cursor-pointer">
            <img
              src={aicomicLogo}
              alt="ComiAI Technology"
              className="h-10 w-auto"
            />
          </a>

          <div className="flex items-center space-x-8">
            <a href="/" className="text-sm text-gray-700 hover:text-gray-900 transition-colors font-bold cursor-pointer">
              {t.home}
            </a>
            <a href="/aicomic" className="text-sm text-gray-900 font-bold cursor-pointer">
              {t.aiComic}
            </a>
            <a href="/emotional-ai" className="text-sm text-gray-700 hover:text-gray-900 transition-colors font-bold cursor-pointer">
              {t.emotionalAi}
            </a>
            <a
              href="https://apps.apple.com/us/app/alcomic/id6744306216?platform=iphone"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2 bg-gray-900 text-white text-sm rounded-full hover:bg-gray-800 hover:shadow-md transition-all font-bold whitespace-nowrap cursor-pointer"
            >
              {t.download}
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
